import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { PaginationTypes } from 'types/sharedResponse'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'

type Job = {
  id: number
  title_en: string
  title_ar: string
  title_i18n: string
  is_deleted: boolean
}

type JobWorkflowStage = {
  id: number
  stage_name: string
  stage_name_i18n: string
}

type AttachmentFields = {
  name: string
  url: string
}

type ScreeningQuestionsResponse = {
  title: string
  text: string[]
  question_type: string
  position: number
  auto_rejected_answer?: boolean
  attachment_fields: AttachmentFields
}

export type ApplicationSubmisions = {
  job: Job
  job_workflow_stage: JobWorkflowStage
  job_form_id: number
  is_auto_reject?: boolean
  created_at: string
  locale: string
  screening_questions_response: ScreeningQuestionsResponse[]
}

type InitialStateType = {
  application_submisions: ApplicationSubmisions[]
  fetching: boolean
  pagination: PaginationTypes
}

const initialState: InitialStateType = {
  application_submisions: [],
  fetching: false,
  pagination: {
    current_page: 1,
    next_page: 1,
    page: 1,
    per_page: 1,
    total_entries: 1,
    total_pages: 1,
  },
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.GET_APPLICATIONS_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.GET_APPLICATIONS_FULFILLED: {
      return {
        ...state,
        application_submisions: action?.payload.data.data.application_submisions,
        fetching: false,
        pagination: action?.payload.data.pagination,
      }
    }

    case actions.GET_APPLICATIONS_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }
    default:
      return state
  }
}
